import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Trash2, Loader2 } from "lucide-react";
import { useLang } from "../../i18n/LangContext";
import { api } from "../../lib/api";

export const DeleteExamplesButton = ({ count, onDone }) => {
  const { t } = useLang();
  const c = t.cleanup;
  const run = async () => {
    if (!count) return toast.info(c.noExamples);
    if (!window.confirm(c.confirmExamples(count))) return;
    try { const { data } = await api.delete("/admin/experts/examples"); toast.success(c.examplesDone(data.deleted)); onDone(); }
    catch { toast.error(t.errors.generic); }
  };
  return (
    <button type="button" className="btn btn-danger btn-sm" onClick={run} data-testid="admin-delete-examples-btn">
      <Trash2 aria-hidden="true" />{c.deleteExamples} ({count})
    </button>
  );
};

export const TestDataPurge = () => {
  const { t } = useLang();
  const c = t.cleanup;
  const [preview, setPreview] = useState(null);
  const [busy, setBusy] = useState(false);
  const load = useCallback(async () => setPreview((await api.get("/admin/test-data")).data), []);
  useEffect(() => { load(); }, [load]);

  const purge = async () => {
    if (!window.confirm(c.confirmPurge)) return;
    setBusy(true);
    try { await api.post("/admin/test-data/purge"); toast.success(c.purgeDone); await load(); }
    catch { toast.error(t.errors.generic); }
    setBusy(false);
  };

  if (!preview) return null;
  const rows = Object.entries(preview).map(([k, v]) => [k, Array.isArray(v) ? (v.length ? `${v.length} — ${v.join(", ")}` : "0") : typeof v === "boolean" ? (v ? c.yes : c.no) : String(v)]);
  const empty = Object.values(preview).every((v) => (Array.isArray(v) ? !v.length : !v));
  return (
    <div className="danger-zone" data-testid="admin-test-data-panel">
      <h3 className="sub-title">{c.title}</h3>
      <p className="pro-intro" style={{ marginTop: 10 }}>{c.desc}</p>
      {empty ? <p className="f-note" data-testid="admin-test-data-empty">{c.nothing}</p> : (
        <>
          <p className="console-title">{c.preview}</p>
          <ul className="purge-list" data-testid="admin-test-data-preview">
            {rows.map(([k, v]) => <li key={k}><span>{c.labels[k]}</span><b>{v}</b></li>)}
          </ul>
          <button type="button" className="btn btn-danger" onClick={purge} disabled={busy} data-testid="admin-purge-test-data-btn">
            {busy ? <Loader2 className="spin" aria-hidden="true" /> : <Trash2 aria-hidden="true" />}{c.purge}
          </button>
        </>
      )}
    </div>
  );
};
